import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Service imports
import { HelperService } from '../../../../_services/shared-services/helper.service';
import { MPCacheRegistrationService } from '../../../../_services/shared-services/mp-cache-registration-service';
// Model imports
import { StatusMessageResultDto } from '../../../../_models/status-message-result-dto';
import { ARInvoiceResultDto } from '../../_models/account-receivable/ar-invoice/ar-invoice-result-dto';
import { TransactionLogResultDto } from '../../_models/common/transaction-log-result-dto';
import { ARInvoiceEditorResultDto } from '../../_models/account-receivable/ar-invoice/ar-invoice-editor-result-dto';
import { GLSubcategorySelectorResultDto } from '../../_models/common/gl-account/glsubcategory-selector-result-dto';
import { GLAccountLabelSelectorResultDto } from '../../_models/common/gl-account/gl-account-label-selector-result-dto';
// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';
import { CacheDuration } from '../../../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../_services/shared-services/helper.service";
import * as i3 from "../../../../_services/shared-services/mp-cache-registration-service";
export class InvoiceDetailsService {
    constructor(httpClient, helperService, cachingService) {
        this.httpClient = httpClient;
        this.helperService = helperService;
        this.cachingService = cachingService;
    }
    getInvoiceDetails(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/detail${params.getQueryString()}`;
        this.cachingService.registerForCache(url, params.clearCache);
        const headers = this.cachingService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        return this.httpClient
            .get(url, { headers })
            .pipe(map((response) => plainToClass(ARInvoiceResultDto, response)));
    }
    downloadSupportDocument(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/supportdocument${params.getQueryString()}`;
        this.helperService.getImageBlobFromUrl(url).subscribe((blob) => {
            this.helperService.downloadFileUsingBlob(blob, params.fileName);
        });
    }
    waiveInvoiceCharges(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/waive`;
        return this.httpClient
            .put(url, classToPlain(params))
            .pipe(map((response) => plainToClass(StatusMessageResultDto, response)));
    }
    getInvoiceHistory(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/history${params.getQueryString()}`;
        this.cachingService.registerForCache(url, params.clearCache);
        const headers = this.cachingService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        return this.httpClient
            .get(url, { headers })
            .pipe(map((response) => plainToClass(TransactionLogResultDto, response)));
    }
    getPrintARInvoice(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/print${params.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((responseData) => new Blob([responseData])));
    }
    reverseARInvoice(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/reverse`;
        return this.httpClient.put(url, classToPlain(params));
    }
    deleteARInvoice(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}`;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: classToPlain(params)
        };
        return this.httpClient.delete(url, options);
    }
    writeOffARInvoice(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/write-off`;
        return this.httpClient.put(url, classToPlain(params));
    }
    getARInvoiceEditor(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/editor${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((response) => plainToClass(ARInvoiceEditorResultDto, response)));
    }
    getARInvoiceGLAccountLabels(param) {
        const url = `${URLConstants.ccInvoiceApiUrl}/glaccountlabels${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(GLAccountLabelSelectorResultDto, response)));
    }
    getARInvoiceSubcategories(params) {
        const url = `${URLConstants.ccInvoiceApiUrl}/subcategories${params.getQueryString()}`;
        this.cachingService.registerForCache(url, params.clearCache);
        const headers = this.cachingService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        return this.httpClient
            .get(url, { headers })
            .pipe(map((response) => plainToClass(GLSubcategorySelectorResultDto, response)));
    }
    updateARInvoice(params) {
        const url = URLConstants.ccInvoiceApiUrl;
        return this.httpClient.put(url, classToPlain(params));
    }
}
InvoiceDetailsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InvoiceDetailsService_Factory() { return new InvoiceDetailsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.MPCacheRegistrationService)); }, token: InvoiceDetailsService, providedIn: "root" });
